// extracted by mini-css-extract-plugin
export default {"formContainer":"SingleLocationPage_formContainer__2Oz9o","detailsContainer":"SingleLocationPage_detailsContainer__Q-bsc"};